import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import PasswordStrength, { validatePassword } from '../components/PasswordStrength';
import { useAuth } from '../context/AuthContext';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [form, setForm] = useState({ current_password:'', new_password:'', confirm_password:'' });
  const [show, setShow] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));
  const toggleShow = k => () => setShow(s => ({ ...s, [k]: !s[k] }));

  const handleSubmit = async e => {
    e.preventDefault(); setError('');
    const err = validatePassword(form.new_password);
    if (err) { setError(err); return; }
    if (form.new_password !== form.confirm_password) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/change_password.php', form);
      if (data.success) { await refreshUser(); navigate('/dashboard'); }
      else setError(data.error || 'Failed');
    } catch { setError('Network error'); }
    finally { setLoading(false); }
  };

  const PwField = ({ k, label, placeholder }) => (
    <div>
      <label className="lbl">{label}</label>
      <div style={{ position:'relative' }}>
        <input className="input" type={show[k] ? 'text' : 'password'} value={form[k]} onChange={set(k)} placeholder={placeholder} required style={{ paddingRight:40 }} />
        <button type="button" onClick={toggleShow(k)} style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:16 }}>
          {show[k] ? '🙈' : '👁'}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,#0f2544 0%,#1a3a6b 50%,#0d9488 100%)', padding:16 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ textAlign:'center', marginBottom:20 }}>
          <div style={{ width:56, height:56, background:'#f59e0b', borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, margin:'0 auto 12px' }}>🔒</div>
          <h1 style={{ color:'#fff', fontSize:22, fontWeight:700 }}>Set Your Password</h1>
          <p style={{ color:'rgba(255,255,255,.6)', fontSize:13, marginTop:4 }}>Your account requires a new password to continue.</p>
        </div>

        <div style={{ background:'#fff', borderRadius:18, padding:'28px 24px', boxShadow:'0 20px 60px rgba(0,0,0,.25)' }}>
          <div className="alert alert-warning" style={{ marginBottom:18, fontSize:12 }}>
            ⚠️ Password must be 8+ characters with uppercase, lowercase, number and symbol.
          </div>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <PwField k="current_password" label="Current Password" placeholder="Your current password" />
            <div>
              <PwField k="new_password" label="New Password" placeholder="Create a strong password" />
              <PasswordStrength password={form.new_password} />
            </div>
            <div>
              <PwField k="confirm_password" label="Confirm Password" placeholder="Re-enter your password" />
              {form.confirm_password && form.new_password !== form.confirm_password && (
                <p style={{ fontSize:11, color:'var(--danger)', marginTop:4 }}>Passwords do not match</p>
              )}
            </div>
            {error && <div style={{ background:'#fef2f2', border:'1px solid #fca5a5', color:'#b91c1c', padding:'10px 14px', borderRadius:8, fontSize:13 }}>{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ width:'100%', justifyContent:'center', padding:'12px', marginTop:4 }}>
              {loading ? 'Saving…' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
